import { Component } from '@angular/core';
import {SubscribedComponent} from "../../subscribed.component";

// Sidebar entry. Wraps ClientCvsTabComponent (generate + Studio link + history)
// and StudioComponent as router children. Authorization on route (UserRole.ADMIN)
// + CvController policy; this component owns layout only.
@Component({
  selector: 'bst-cv-generator-page',
  templateUrl: './cv-generator-page.component.html',
  styleUrls: ['./cv-generator-page.component.scss'],
  standalone: false,
})
export class CvGeneratorPageComponent extends SubscribedComponent {

  get headerTitle(): string | { title: string; translate: boolean | Object } {
    return 'CV generator';
  }
}
